export default __webpack_public_path__ + "static/media/ask_me_icon.8f428643.svg";